import { useJsApiLoader } from '@react-google-maps/api';

interface CenterProps {
    lat: number;
    lng: number;
};

const useMap = () : {isLoaded: boolean, center: CenterProps} => {

    const { isLoaded } = useJsApiLoader({id: 'google-map-script', googleMapsApiKey: "AIzaSyBlshAaDTkiFBm0_S3KZZcF5eaYVjFQ9oU"});

    const center = {
        lat: 19.396738,
        lng: -99.140635
    };


    return {
        isLoaded,
        center
    }
}

export default useMap
